(function (window) {
  function BatchGeoTableContextMenu() {
    var strings = BatchGeoStrings.getStringsForComponent(
      "BatchGeoTableContextMenu",
    );
    return BatchGeoContextMenu({
      triggerEl: "#dataView",
      menuItems: [
        {
          label: strings.get("COPY"),
          icon: "context-copy",
          visibility: [!window.per.disable_exports],
          disabled: function () {
            if (!window.batchGeoTableMap) return true;
            var rowQty =
              window.batchGeoTableMap.batchGeoTable.RowSelect.getSelectedRows()
                .length;
            return rowQty < 1;
          },
          callback: function () {
            var batchGeoCopyMachine = window.BatchGeoCopyMachine();
            var batchGeoTable = window.batchGeoTableMap.batchGeoTable;
            batchGeoCopyMachine.copyContents(function () {
              // Save the content here so when we destroy the component
              // the content still lives

              var content = window.TableExporter({
                columns: batchGeoTable.data.columns,
                rows: batchGeoTable.RowSelect.getSelectedRows(),
                sortAgainst: batchGeoTable.getDisplayData(),
              });

              // Destroy the content textarea so they don't keep stacking
              // up in the DOM each time you right click copy
              batchGeoCopyMachine.destroy();
              return content;
            }, true);
          },
        },
        {
          label: strings.get("SELECT_ALL"),
          icon: "context-select-all",
          callback: function () {
            var batchGeoTable = window.batchGeoTableMap.batchGeoTable;
            batchGeoTable.RowSelect.selectAll();
          },
        },
        {
          label: strings.get("RESET_TABLE"),
          icon: "context-reset",
          callback: function () {
            BatchGeoStore.dispatch({ type: "ROW_SELECT_DESELECTALL" });
            BatchGeoStore.dispatch({ type: "HEADER_SORT_DEFAULT" });
            window.batchGeoGoogleMapsMarker.MarkerLegend.clearFilters();
          },
        },
        {
          label: strings.get("ZOOM_TO_MARKER"),
          icon: "context-zoom",
          callback: function () {
            const state = BatchGeoStore.getState();
            const selectedRows = state.RowSelect.selection;
            const tm = window.batchGeoTableMap;
            if (selectedRows.length > 1) {
              const shouldRefreshClarker =
                state.Cluster.enabled && selectedRows.length > 1;
              const options = Object.assign(state.RowSelect.options, {
                shouldRefreshClarker: shouldRefreshClarker,
              });
              tm._onRowSelect(selectedRows, options);
            } else if (selectedRows.length === 1) {
              const googleMarkers = tm.getGoogleMarkersFromRows(selectedRows);
              tm.fitMarkers(googleMarkers);
            } else {
              const triggeringRow = state.BatchGeoContextMenu.triggeringRow;
              BatchGeoStore.dispatch([
                {
                  type: "ROW_SELECT_SELECT",
                  selectedRows: [triggeringRow],
                },
                {
                  type: "FEATURE_TOGGLE",
                  feature: "shouldRenderTable",
                },
              ]);
              window.batchGeoGoogleMapsMarker.MarkerContent.pointToZoom();
            }
          },
        },
        {
          label: strings.get("OPTIMAL_ROUTE"),
          icon: "context-direction",
          visibility: [BatchGeoStore.getState().App.pro],
          disabled: function () {
            if (!window.batchGeoTableMap) return true;
            var rowQty =
              window.batchGeoTableMap.batchGeoTable.RowSelect.getSelectedRows()
                .length;
            return rowQty < 2;
          },
          callback: function () {
            BatchGeoStore.dispatch({
              type: "OPTIMAL_ROUTE_MODAL_VISIBILITY",
              isVisible: true,
            });
          },
        },
      ],
    });
  }

  window.BatchGeoTableContextMenu = BatchGeoTableContextMenu;
})(window);
